import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export function useDicts() {
  const [dicts, setDicts] = useState({ companies: [], projects: [], categories: [], counterparties: [], currencies: [] });

  const reload = useCallback(async () => {
    const kinds = ["companies", "projects", "categories", "counterparties", "currencies"];
    const res = await Promise.all(kinds.map((k) => api.get(`/dict/${k}`).then((r) => r.data).catch(() => [])));
    setDicts(Object.fromEntries(kinds.map((k, i) => [k, res[i]])));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { dicts, reload };
}
